import { camelizeKeys } from 'humps';
import { asyncPost } from './httpClientUtils';
import { makeGetPartnerPageUrl } from '../utils/urlProvider';

class PartnerPageApi {
  getPartnerPage = async (systemName, query) => {
    const response = await asyncPost(makeGetPartnerPageUrl(systemName), { query });
    return camelizeKeys(response);
  }
}

export default new PartnerPageApi();
